import React from 'react';
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import App from './App';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service workers + caching cause blank screens in WKWebView when the shell loads bundled files.
if (!Capacitor.isNativePlatform()) {
  serviceWorkerRegistration.register();
}
